export const STAGE_ORDER = ["new", "site_eval", "proposal", "estimate", "contract", "signed", "mm_review", "lost", "nurturing"];

export const STAGE_LABEL = {
  new: { zh: "新线索", en: "New" }, site_eval: { zh: "现场评估", en: "Site Eval" },
  proposal: { zh: "方案", en: "Proposal" }, estimate: { zh: "报价", en: "Estimate" },
  contract: { zh: "合同", en: "Contract" }, signed: { zh: "已签约", en: "Signed" },
  mm_review: { zh: "市场部经理复核", en: "MM Review" },
  lost: { zh: "无效流失", en: "Invalid/Lost" }, nurturing: { zh: "培育", en: "Nurturing" },
};

export const STAGE_COLOR = {
  new: "#4b5b75", site_eval: "#6d28d9", proposal: "#7e22ce", estimate: "#b45309",
  contract: "#c2410c", signed: "#15803d", mm_review: "#a16207",
  lost: "#b91c1c", nurturing: "#5f6f8a",
};

// 仅在新建/推进流程中可选的正向阶段(不含复核/流失/培育终态)
export const ACTIVE_STAGE_ORDER = ["new", "site_eval", "proposal", "estimate", "contract", "signed"];

export const TEMP_LABEL = {
  hot: { zh: "高意向", en: "Hot", color: "#b91c1c" }, warm: { zh: "中意向", en: "Warm", color: "#9a3412" },
  cold: { zh: "低意向", en: "Cold", color: "#0369a1" }, nurturing: { zh: "培育中", en: "Nurturing", color: "#5f6f8a" },
  invalid: { zh: "无效", en: "Invalid", color: "#475569" },
};

export const TYPE_LABEL = {
  detached_adu: { zh: "独立 ADU", en: "Detached ADU" }, attached_adu: { zh: "附属 ADU", en: "Attached ADU" },
  garage_conversion: { zh: "车库改造", en: "Garage Conversion" }, junior_adu: { zh: "Junior ADU", en: "Junior ADU" },
  two_story_adu: { zh: "二层 ADU", en: "Two-story ADU" },
  addition: { zh: "加建", en: "Addition" }, new_construction: { zh: "新建", en: "New Construction" },
  remodel: { zh: "改造", en: "Remodel" }, fire_rebuild: { zh: "火灾重建", en: "Fire Rebuild" },
  new_jadu: { zh: "新建 JADU", en: "New JADU" }, new_main_house: { zh: "新建主屋", en: "New Primary House" }, new_multifamily: { zh: "新建多单位住宅", en: "New Multi-family" },
};

const REGION_FALLBACK = {
  hq: { zh: "公司总部", en: "Headquarters" }, la: { zh: "洛杉矶", en: "Los Angeles" },
  norcal: { zh: "北加州", en: "Northern California" }, nc: { zh: "北加州", en: "Northern California" },
  sd: { zh: "圣地亚哥", en: "San Diego" },
};
export const regionLabel = (regions, id, zh) => {
  // 兼容两种调用: (regions, id, zh) 或 (id, zh)
  if (!Array.isArray(regions)) { zh = id; id = regions; regions = []; }
  const r = (regions || []).find((x) => x.id === id);
  if (r) return zh ? r.zh : r.en;
  const f = REGION_FALLBACK[id];
  if (f) return zh ? f.zh : f.en;
  return id || "-";
};

export const AFTERSALES_TYPE = {
  warranty: { zh: "保修", en: "Warranty" }, service: { zh: "服务", en: "Service" },
  complaint: { zh: "投诉", en: "Complaint" }, maintenance: { zh: "保养", en: "Maintenance" },
  callback: { zh: "回访", en: "Callback" },
};
export const AFTERSALES_STATUS = {
  open: { zh: "待处理", en: "Open", color: "#f97316" }, in_progress: { zh: "处理中", en: "In Progress", color: "#0ea5e9" },
  resolved: { zh: "已解决", en: "Resolved", color: "#16a34a" }, closed: { zh: "已关闭", en: "Closed", color: "#64748b" },
};
export const REFERRAL_STATUS = {
  new: { zh: "新转介", en: "New", color: "#6366f1" }, contacted: { zh: "已联系", en: "Contacted", color: "#0ea5e9" },
  converted: { zh: "已转化", en: "Converted", color: "#16a34a" }, declined: { zh: "已流失", en: "Declined", color: "#dc2626" },
};
